'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WorkArea = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _createTemplateComponent = require('helpers/createTemplateComponent');

var _createTemplateComponent2 = _interopRequireDefault(_createTemplateComponent);

var _templateModeTypes = require('constants/templateModeTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WorkArea = exports.WorkArea = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(WorkArea, _Component);

  function WorkArea() {
    (0, _classCallCheck3.default)(this, WorkArea);
    return (0, _possibleConstructorReturn3.default)(this, (WorkArea.__proto__ || (0, _getPrototypeOf2.default)(WorkArea)).apply(this, arguments));
  }

  (0, _createClass3.default)(WorkArea, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          root = _props.root;

      var RootComponent = (0, _createTemplateComponent2.default)(root, _templateModeTypes.EDITOR);
      var styles = require('./WorkArea.scss');

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(className, styles.root) },
        (RootComponent || null) && _react2.default.createElement(RootComponent, null)
      );
    }
  }]);
  return WorkArea;
}(_react.Component), _class.propTypes = {
  root: _react.PropTypes.object,
  className: _react.PropTypes.string
}, _temp);


var mapStateToProps = function mapStateToProps(state) {
  var template = state.templateApplication.templates.currentTemplate;
  var components = template && template.components;

  return {
    root: components && components.root
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(WorkArea);


//////////////////
// WEBPACK FOOTER
// ./src/containers/TemplateEditor/WorkArea/WorkArea.jsx
// module id = 1647
// module chunks = 0